import { Card4 } from '../../../../_metronic/partials/content/cards/Card4';
import { ListsWidget6 } from '../../../../_metronic/partials/widgets';

export default function SupportButtons() {

    return(
        <>
              {/* begin::Row */}
              <div className='row g-5 g-xl-8'>
                <div className='col-xl-3'></div>
        
                <div className='col-xl-6'>
                    <div className="card card-custom ">
                        <div className="card-header align-items-center bg-marino">
                            <h3 className="card-title text-secondary  fw-bolder">Client Support</h3>
                        </div>
                        <div className="card-body">
                        <form className='form w-100' id='kt_login_signin_form'>
                                {/* begin::Heading */}
                             
                                <div className='text-center mb-4'>
                                <h1 className='f-titulo text-marino fw-bolder  fs-md'>How can we help you?</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                               
                                {/* begin::Action */}
                                <br />
                                <div className='d-grid mb-10'>
                                <ListsWidget6 className=''></ListsWidget6>
                                
                                </div>
                                {/* end::Action */}

                            </form>
                        </div>
                        
                    </div>
                    

                </div>
        
                <div className='col-xl-3'></div>
              </div>
              {/* end::Row */} 
            </>
      
        

      
    )
    }